var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchboxHhmtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M0 0h32v20H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-24-444h375v667H-24z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.25,
    width: 30.5,
    height: 17.5,
    rx: 8.75,
    fill: "#fff",
    stroke: "#B0B6BD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 10,
    r: 6,
    fill: "#B0B6BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 -266)",
    d: "M0 0h327v401H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchboxHhmtIcon);
export default __webpack_public_path__ + "static/media/switchbox-hhmt-icon.2fb6465accaa58b0d7300cef86133d78.svg";
export { ForwardRef as ReactComponent };